function verificarQuantidade(dose) {
  if (!dose || isNaN(dose)) return 0
  if (dose >= 1000) return dose / 1000
  return dose
}

export function calculoVolumeDose(dose, volume, formulacao) {
  const doseNum = Number(dose)
  const volumeNum = parseFloat(String(volume || '').replace(',', '.'))

  // Se algum deles for inválido, retorna 0.00 diretamente
  if (isNaN(doseNum) || isNaN(volumeNum) || !formulacao) {
    return '0.00'
  }

  const quantidade = doseNum * volumeNum
  const valor = verificarQuantidade(quantidade)?.toFixed(2)

  if (['Líquida', 'Gel'].includes(formulacao)) {
    return `${valor} ${quantidade >= 1000 ? 'L/ha' : 'mL/ha'}`
  }

  if (['Turfosa', 'Liofilizada', 'Sólido'].includes(formulacao)) {
    return `${valor} ${quantidade >= 1000 ? 'kg/ha' : 'g/ha'}`
  }

  return '0.00'
}